import React from 'react';
import { useSelector } from 'react-redux';
import AdvncShiftReportHeader from './AdvncShiftReportHeader';
import BillTypeSummaryPrint from './BillTypeSummaryPrint';
import DeliveryPartnerSummaryPrint from './DeliveryPartnerSummaryPrint';
import DeliveryBoysSummaryPrint from './DeliveryBoysSummaryPrint';
import DiscountSummaryPrint from './DiscountSummaryPrint';
import CategorySalesSummaryPrint from './CategorySalesSummaryPrint';
import TaxDetailsPrint from './TaxDetailsPrint';
import ShiftReceiptPrint from './ShiftReceiptPrint';
import ShiftDevicePrint from './ShiftDevicePrint';
import BillTypeTemplateSummaryPrint from './BillTypeTemplateSummaryPrint';
import StarHorizontalLine from '../../../../Single Components/StarHorizontalLine';
import './AdvanceSummaryFullPrintA4.css';

const AdvanceSummaryFullPrintA4 = () => {
  const template = useSelector((state) => state?.salesQuatationSlice?.setTemplate);

  return (
    <div className="a4-shift-report">
      <div className="section-container">
        <AdvncShiftReportHeader />
      </div>

      <div className="section-container">
        {template?.shiftReportReceiptTemplate === "template2" ? (
          <BillTypeSummaryPrint />
        ) : (
          <BillTypeTemplateSummaryPrint />
        )}
      </div>

      <StarHorizontalLine />

      <div className="section-container">
        <DeliveryPartnerSummaryPrint />
      </div>

      <StarHorizontalLine />

      <div className="section-container">
        <DeliveryBoysSummaryPrint />
      </div>

      <StarHorizontalLine />

      <div className="section-container">
        <DiscountSummaryPrint />
      </div>

      <StarHorizontalLine />

      <div className="section-container">
        <TaxDetailsPrint />
      </div>

      <StarHorizontalLine />

      <div className="section-container">
        <CategorySalesSummaryPrint />
      </div>

      <StarHorizontalLine />

      <div className="section-container">
        <ShiftReceiptPrint />
      </div>

      <StarHorizontalLine />

      <div className="section-container">
        <ShiftDevicePrint />
      </div>
    </div>
  );
};

export default AdvanceSummaryFullPrintA4;
